import type IMembershipPeriodMessagingDismissalElements from './IMembershipPeriodMessagingDismissalElements';

export default {
  getAll() {
    const $containers = document.querySelectorAll<HTMLDivElement>('.tn-utility-nav-membership-period-messaging__container[data-tn-membership-id]');

    return Array.from($containers).map(($container) => ({
      $container,
      $closeButton: $container.querySelector<HTMLButtonElement>('.tn-utility-nav-membership-period-messaging__close-btn'),
      membershipId: $container.getAttribute('data-tn-membership-id') || '',
    }));
  },
} as IMembershipPeriodMessagingDismissalElements;
